module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/couple-93d9f343b6d4570bf43782f17c410d24.webp";